(function () {
    'use strict';

    angular
        .module('app')
        .factory('errorService', errorService);

    errorService.$inject = ['$http'];

    function errorService($http) {
        var service = {
            getData: getData
        };

        service.errors = [];


        return service;

        function getData() { }
    }
})();